import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/lib/i18n";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import HowItWorks from "@/components/landing/HowItWorks";
import Partners from "@/components/landing/Partners";
import Faq from "@/components/landing/Faq";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

function Landing() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <HowItWorks />
        <Partners />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-[#110E0C] text-[#F9F6F0]">
          <div className="grain-overlay" aria-hidden="true" />
          <Routes>
            <Route path="/" element={<Landing />} />
          </Routes>
          <Toaster position="bottom-center" theme="dark" />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
